import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

export function useAcl() {
	const authStore = useAuthStore();

	const can = (value) => {
		const permissions = authStore.user.permissions;
		if (!Array.isArray(permissions)) return false;

		if (value.includes('|')) {
			return value.split('|').some((item) => permissions.includes(item.trim()));
		}
		if (value.includes('&')) {
			return value.split('&').every((item) => permissions.includes(item.trim()));
		}
		return permissions.includes(value.trim());
	};

	const hasRole = (value) => {
		const roles = authStore.user.roles;
		if (!Array.isArray(roles)) return false;

		if (value.includes('|')) {
			return value.split('|').some((item) => roles.includes(item.trim()));
		}
		if (value.includes('&')) {
			return value.split('&').every((item) => roles.includes(item.trim()));
		}
		return roles.includes(value.trim());
	};

	const hasAnyRole = (value) => {
		return hasRole(value); // `|` logic is covered in hasRole
	};

	const hasAllRoles = (value) => {
		const roles = authStore.user.roles;
		if (!Array.isArray(roles)) return false;
		return value.split('|').every((item) => roles.includes(item.trim()));
	};

	const unlessRole = (value) => {
		return !hasRole(value);
	};

	const hasExactRoles = (value) => {
		const roles = authStore.user.roles;
		if (!Array.isArray(roles)) return false;
		const roleList = value.split('|').map((item) => item.trim());
		return roles.length === roleList.length && roleList.every((role) => roles.includes(role));
	};

	return {
		can,
		hasRole,
		hasAnyRole,
		hasAllRoles,
		unlessRole,
		hasExactRoles,
	};
}
